import React from "react"
import classnames from "classnames"
import { arrayOf, func, number, oneOfType, string, node } from "prop-types"

const AttendeeTypeGradeFilter = ({
  gradeOptions,
  gradeRestrictionPhrase,
  maxGrade,
  minGrade,
  onGradeRestrictionPhraseChange,
  onMaxGradeChange,
  onMinGradeChange,
  children
}) => {
  const minGradeFieldClassname = {
    "select w-a": true
  }
  const maxGradeFieldClassname = {
    "select w-a": true,
    "d-n": gradeRestrictionPhrase === "only"
  }

  return (
    <div className="mb-2 d-f ai-c g-1 fw-w">
      {children}
      <select
        name="grade_restriction_phrase"
        id="grade_restriction_phrase"
        className="select select--inline"
        value={gradeRestrictionPhrase}
        onChange={onGradeRestrictionPhraseChange}
      >
        <option value="between">between</option>
        <option value="only">only</option>
      </select>

      <select
        name="attendee_type[min_grade]"
        id="attendee_type_min_grade"
        className={classnames(minGradeFieldClassname)}
        value={minGrade}
        onChange={onMinGradeChange}
      >
        {gradeOptions.map(option => (
          <option key={option[0]} value={option[1]}>
            {option[0]}
          </option>
        ))}
      </select>

      {gradeRestrictionPhrase === "between" && <span>and</span>}

      <select
        name="attendee_type[max_grade]"
        id="attendee_type_max_grade"
        className={classnames(maxGradeFieldClassname)}
        value={maxGrade}
        onChange={onMaxGradeChange}
      >
        {gradeOptions.map(option => (
          <option key={option[0]} value={option[1]}>
            {option[0]}
          </option>
        ))}
      </select>
    </div>
  )
}

const gradeOption = arrayOf(oneOfType([string, number])).isRequired

AttendeeTypeGradeFilter.propTypes = {
  gradeOptions: arrayOf(gradeOption).isRequired,
  gradeRestrictionPhrase: string.isRequired,
  maxGrade: oneOfType([string, number]).isRequired,
  minGrade: oneOfType([string, number]).isRequired,
  onGradeRestrictionPhraseChange: func.isRequired,
  onMaxGradeChange: func.isRequired,
  onMinGradeChange: func.isRequired,
  children: node
}

export default AttendeeTypeGradeFilter
